import { RENTAL_PORTAL_VIEWING_STATUS } from '../../constants/rentalPortal'

export { RENTAL_PORTAL_VIEWING_STATUS_SLOT_OPEN } from '../../constants/rentalPortal'

export const VIEWING_STATUS_CHANGE_COPY = {
  [RENTAL_PORTAL_VIEWING_STATUS.cancelled]: {
    descriptionKey: 'RentalPortal.ViewingCancelConfirmationTextKey',
    notificationKey: 'RentalPortal.ViewingCancelledNotificationKey',
    submitKey: 'RentalPortal.ViewingCancelActionKey',
  },
  [RENTAL_PORTAL_VIEWING_STATUS.completed]: {
    descriptionKey: 'RentalPortal.ViewingCompletedConfirmationTextKey',
    notificationKey: 'RentalPortal.ViewingCompletedNotificationKey',
    submitKey: 'RentalPortal.ViewingCompletedActionKey',
  },
  [RENTAL_PORTAL_VIEWING_STATUS.noShow]: {
    descriptionKey: 'RentalPortal.ViewingNoShowConfirmationTextKey',
    notificationKey: 'RentalPortal.ViewingNoShowNotificationKey',
    submitKey: 'RentalPortal.ViewingNoShowActionKey',
  },
}

export const IS_VIEWING_BOOKING_AVAILABLE = true

export const VIEWINGS_FILTER_PARAM = {
  booked: 'booked',
  listing: 'listing',
  manager: 'manager',
  responsibleUser: 'responsible_user',
  startGte: 'start_gte',
  startLte: 'start_lte',
  status: 'status',
}

export const VIEWINGS_FILTER_DATE_NAME = 'start'

export const VIEWING_MASS_ACTION = {
  archive: 'archive',
  restore: 'restore',
}

export const VIEWING_COLUMN_NAME = {
  Applicant: 'applicant_label',
  DateTime: 'start',
  Listing: 'listing_label',
  Manager: 'manager_label',
  Status: 'status',
}

export const VIEWING_COLUMN_CONFIG = {
  [VIEWING_COLUMN_NAME.Applicant]: {
    index: 2,
    title: 'RentalPortal.ViewingApplicantColumnKey',
    width: 240,
  },
  [VIEWING_COLUMN_NAME.DateTime]: {
    index: 0,
    title: 'RentalPortal.ViewingDateTimeColumnKey',
    width: 292,
  },
  [VIEWING_COLUMN_NAME.Listing]: {
    index: 1,
    title: 'RentalPortal.ViewingListingColumnKey',
    width: 260,
  },
  [VIEWING_COLUMN_NAME.Manager]: {
    index: 4,
    title: 'RentalPortal.ViewingManagerColumnKey',
    width: 200,
  },
  [VIEWING_COLUMN_NAME.Status]: {
    index: 3,
    title: 'RentalPortal.ViewingStatusColumnKey',
    width: 160,
  },
}

export const LISTING_VIEWING_ACTION_OPEN = 'open'

export const LISTING_VIEWING_ROW_ACTIONS = [
  {
    label: 'RentalPortal.ListingProfileViewingsOpenActionOptionKey',
    value: LISTING_VIEWING_ACTION_OPEN,
  },
]
